import './LoadingSkeleton.css'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  borderRadius?: string | number
  style?: React.CSSProperties
}

/** Single skeleton block — use to build layout-specific skeletons */
export function Skeleton({ width = '100%', height = 16, borderRadius = 6, style }: SkeletonProps) {
  return (
    <div
      className="skeleton-pulse"
      style={{
        width,
        height,
        borderRadius,
        backgroundColor: 'var(--border)',
        flexShrink: 0,
        ...style,
      }}
    />
  )
}

/** Deck card skeleton used in grids */
export function DeckCardSkeleton() {
  return (
    <div
      style={{
        backgroundColor: 'var(--bg-secondary)',
        borderRadius: 16,
        padding: 20,
        border: '1px solid var(--border)',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
        <Skeleton width={44} height={44} borderRadius="50%" />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Skeleton width="65%" height={14} />
          <Skeleton width="40%" height={12} />
        </div>
      </div>
      <Skeleton width="100%" height={6} borderRadius={50} />
      <div style={{ display: 'flex', gap: 8 }}>
        <Skeleton width={64} height={28} borderRadius={50} />
        <Skeleton width={64} height={28} borderRadius={50} />
      </div>
    </div>
  )
}

/** Stat card skeleton for dashboard hero widgets */
export function StatCardSkeleton() {
  return (
    <div
      style={{
        backgroundColor: 'var(--bg-surface)',
        borderRadius: 16,
        padding: 24,
        border: '1px solid var(--border)',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <Skeleton width={120} height={13} />
      <Skeleton width={64} height={36} borderRadius={8} />
      <Skeleton width={140} height={12} />
    </div>
  )
}

/** List row skeleton */
export function ListRowSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Skeleton width={36} height={36} borderRadius="50%" />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
            <Skeleton width={`${55 + (i % 3) * 15}%`} height={13} />
            <Skeleton width={`${30 + (i % 2) * 10}%`} height={11} />
          </div>
        </div>
      ))}
    </div>
  )
}
